<script>
import KnowledgeUseData from "@/components/training/scene/kefu/KnowledgeUseData.vue";
import TransData from "@/components/training/scene/kefu/TransData.vue";
import TodayData from "@/components/training/scene/kefu/TodayData.vue";

export default {
    data() {
        return {
            navList: ["人工客服数据", "智能客服数据"],
            active: 0,
            aiIndex: 0,
            aiNavList: ["今日数据", "知识使用数据", "接待转化数据"]
        }
    },
    components: {
        KnowledgeUseData,
        TransData,
        TodayData,
    }
}
</script>
<template>
    <div class="kefu-data-container">
        <el-scrollbar style="height: 100%;">
            <div class="nav-wrap-list">
                <div class="nav-item" v-for="(value, index) in navList" :key="index"
                     :class="index  === active ? 'active' : ''"
                     @click="active = index"
                >
                    {{ value}}
                </div>
            </div>
            <div class="no-more-data" v-if="active === 0">
                <div class="no-image-content">
                    <div class="img-logo">
                        <img :src="require('@/assets/images/training/scene/noAccess.svg')" alt="">
                        <div class="no-desc">
                            <span>暂无授权通过的客服&nbsp;&nbsp;</span>
                            <el-link type="primary" :underline="false">如何绑定？</el-link>
                        </div>
                    </div>
                </div>
            </div>
            <div class="ai-kefu-data-area" v-if="active === 1">
                <div class="ai-nav-wrap-list">
                    <div class="ai-nav-item" v-for="(item, key) in aiNavList"
                         :key="key"
                         :class="aiIndex === key ? 'active' : ''"
                         @click="aiIndex = key"
                    >{{item}}</div>
                </div>
                <div class="data-panel">
                    <today-data v-if="aiIndex === 0" />
                    <knowledge-use-data v-if="aiIndex === 1" />
                    <trans-data v-if="aiIndex === 2" />
                </div>
            </div>
        </el-scrollbar>
    </div>

</template>
<style scoped lang="scss">
.kefu-data-container {
    &, & * {
        box-sizing: border-box;
    }
    &:deep(.el-scrollbar) {
        .el-scrollbar__wrap {
            overflow-x: hidden;
        }
    }
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    .nav-item {
        cursor: pointer;
        padding: 8px 12px;
        border-radius: 4px;
        &.active {
            color: #2a55e5;
            background-color: #e5f5ff;
        }
    }
    .no-more-data {
        background: #FFF;
        width: 100%;
        height: calc(100vh - 260px);
        margin-bottom: 16px;
        border-radius: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        .img-logo {
            .no-desc {
                display: flex;
                justify-content: flex-start;
                align-items: center;
            }
        }
    }
    .ai-kefu-data-area {
        border-radius: 12px;
        padding: 16px 24px;
        background: #FFF;
        .ai-nav-wrap-list {
            height: 59px;
            width: 100%;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            color: #16182380;
        }
        .ai-nav-item {
            margin: 0 20px;
            cursor: pointer;
            height: 40px;
            line-height: 40px;
            &:first-child {
                margin-left: 0;
            }
            font-weight: 500;
            &.active {
                color: #323335;
                font-weight: 600;
                border-bottom: 2px solid #2a55e5;
            }

        }
    }
}
</style>
